import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import PPMeClaimIframe from './ppMeClaimIframeComponent'

class SendPPMeClaimIframe extends React.Component {
  static propTypes = {
    amount: PropTypes.string.isRequired,
    currencyCode: PropTypes.string.isRequired,
    ppmeClaimUrl: PropTypes.string.isRequired,
  }

  render() {
    return (
      <PPMeClaimIframe
        intent="send"
        amount={this.props.amount}
        currencyCode={this.props.currencyCode}
        ppmeClaimUrl={this.props.ppmeClaimUrl}
      />
    )
  }
}

export default connect(({ amount, transaction }) => ({
  amount: amount.amount,
  currencyCode: amount.currencyCode,
  ppmeClaimUrl: transaction.ppmeClaimUrl,
}))(SendPPMeClaimIframe)
